import React, { useEffect, useState } from "react";
import { useThree } from "@react-three/fiber";
import {
  TextureLoader,
  sRGBEncoding,
  EquirectangularReflectionMapping,
} from "three";
import { useClient } from "../../hooks/client-hook";

const Sky = () => {
  const { client } = useClient();
  const [currentSky, setCurrentSky] = useState("");
  const { scene } = useThree();
  const loader = new TextureLoader();

  function setSkyTexture() {
    // Set the scene background property to the resulting texture.
    if (client && client.sky) {
      if (currentSky === client.sky) {
        return;
      }

      const texture = loader.load(client.sky);

      texture.encoding = sRGBEncoding;
      texture.mapping = EquirectangularReflectionMapping;
      scene.background = texture;

      setCurrentSky(client.sky);
    }
  }

  useEffect(() => {
    setSkyTexture();
  }, [client]);

  return null;
};

export default Sky;
